import { render, staticRenderFns } from "./CourseSupportDataTable.vue?vue&type=template&id=b4cabc56&scoped=true"
import script from "./CourseSupportDataTable.vue?vue&type=script&lang=js"
export * from "./CourseSupportDataTable.vue?vue&type=script&lang=js"
import style0 from "./CourseSupportDataTable.vue?vue&type=style&index=0&id=b4cabc56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4cabc56",
  null
  
)

export default component.exports